/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Flex } from "@nordcloud/gnui";
import {
  CustomerCategory,
  CustomerCategoryDisplay,
} from "~/models/customerCategory";
import { MultiSelectButton } from "../Styled/MultiSelectButton";
import { FiltersProp } from "./types";

type Props = {
  value: CustomerCategory[];
  filters: FiltersProp;
  setFilters: (filter: FiltersProp) => void;
};

export function CategoryMultiSelect({ value, filters, setFilters }: Props) {
  const toggleCategory = (category: CustomerCategory) => {
    if (
      filters.category?.find(
        (filterCategory: CustomerCategory) => filterCategory === category
      )
    ) {
      setFilters({
        ...filters,
        category: filters.category?.filter(
          (filterCategory: CustomerCategory) => filterCategory !== category
        ),
      });
    } else {
      setFilters({
        ...filters,
        category: [...(filters.category ?? []), category],
      });
    }
  };

  return (
    <Flex
      justifyContent="flex-start"
      css={{ flexWrap: "wrap", rowGap: "0.5rem" }}
    >
      {Object.values(CustomerCategory).map((category) => (
        <MultiSelectButton
          key={category}
          value={value?.find((c) => c === category)}
          severity="medium"
          onClick={() => toggleCategory(category)}
        >
          {CustomerCategoryDisplay[category]}
        </MultiSelectButton>
      ))}
    </Flex>
  );
}
